import React from 'react';
import { Button, OverlayTrigger, Popover } from 'react-bootstrap';
import { OverlayTriggerType } from 'react-bootstrap/OverlayTrigger';
import { useTranslation } from 'react-i18next';
import { MdClose } from 'react-icons/md';
import { StarProIcon } from '../../../../shared/Icons';
import { ButtonUpgradePro } from './ButtonUpgradePro';
import { useSelector } from 'react-redux';
import { IAllStates } from '../../../../store/rootReducer';
import { Placement } from 'react-bootstrap/esm/types';
import { openCalendlyPopup } from '../../../../shared/functions/Functions';

interface IProps {
    children: JSX.Element;
    show?: boolean;
    trigger?: OverlayTriggerType;
    description: string;
    placement?: Placement;
}

interface IPopoverTopContent {
    description: string;
    t: any;
    show?: boolean;
}

const popoverTop = ({ t, description, show }: IPopoverTopContent) => {
    return (
        <Popover
            id="popover-positioned-scrolling-top"
            className={`popover-package ${show ? '' : 'd-none'}`}
            title={t(`brand.package.${description}`)}
        >
            <div className="d-flex align-items-center justify-content-between ">
                <StarProIcon width="40" height="40" />
                {/* simulate clicking on body to close tooltip */}
                <MdClose className="text-muted" onClick={() => document.body.click()} />
            </div>
            <span className="text-muted font-italic mt-2">
                {t(`brand.package.${description}`)}
                <ButtonUpgradePro variant="outline-primary" className="w-100 mt-1" />
            </span>
        </Popover>
    );
};
const TooltipPackage = ({ children, placement = 'top', description, show = false, trigger = 'focus' }: IProps) => {
    const { t } = useTranslation();
    const { company } = useSelector((state: IAllStates) => state.auth.user);

    return (
        <>
            {company?.package.isShownToUser && description !== 'noBarterDeal' ? (
                <OverlayTrigger
                    rootClose
                    container={this}
                    trigger={trigger}
                    placement={placement}
                    overlay={popoverTop({ t, description, show })}
                >
                    {children}
                </OverlayTrigger>
            ) : (
                <OverlayTrigger
                    rootClose
                    container={this}
                    trigger={trigger}
                    placement={placement}
                    overlay={
                        <Popover
                            id="success-team"
                            className={`popover-package ${show ? '' : 'd-none'}`}
                            title={t(`brand.package.${description}`)}
                        >
                            <div className="d-flex align-items-center justify-content-end mt-2">
                                <MdClose className="text-muted" onClick={() => document.body.click()} />
                            </div>
                            <p className="text-muted font-italic mb-2">{t(`brand.package.info_about_feature`)}</p>
                            <Button
                                className="w-100"
                                onClick={() => openCalendlyPopup(String(process.env.VITE_CUSTOMER_SUCCESS_CALENDLY))}
                                variant="outline-primary"
                            >
                                {t('brand.package.contact_us')}
                            </Button>
                        </Popover>
                    }
                >
                    <div>{children}</div>
                </OverlayTrigger>
            )}
        </>
    );
};

export default TooltipPackage;
